<div class="modal-header">
    <h4>Torque Pass Percentage</h4>
    <a class="close-icon" href="javascript:void()" (click)="closeModal()" ngbAutofocus><i class="flaticon2-cross"></i></a>
</div>
<div *ngIf="form" class="modal-body output-lable">
    <div [formGroup]="form" class="card-body p-6">
        <table class="mat-table mat-table-wrapper">
            <tr class="mat-header-row">
                <th class="mat-header-cell">Pass</th>
                <th class="mat-header-celltwo">Text</th>
                <th class="mat-header-celltwo">Percentage</th>
            </tr>
            <tr class="mat-row" *ngFor="let pass of passState">
                <td class="mat-cell">
                    <mat-checkbox
                        [checked]="pass.checked"
                        class="checkbox-wrap"
                        (change)="checkboxChange(pass, $event)"
                        [aria-label]="pass.visible.key"
                        [value]="pass.checked"
                    >
                        {{ pass.visible.name | passLabelModify }}
                    </mat-checkbox>
                </td>
                <td class="mat-cell">
                    <div class="pass-name-text custom-text-field">
                        <mat-form-field class="text-data" [floatLabel]="'never'">
                            <input type="text" matInput name="{{pass.text.key}}" [formControlName]="pass.text.key" (change)="textBoxChange(pass, $event)" />
                        </mat-form-field>
                        <p class="error-message" *ngIf="form.get(pass.text.key).hasError('required')">Enter some text here</p>
                    </div>
                </td>
                <td class="mat-cell">
                    <div class="pass-name-percentage custom-text-field">
                        <mat-form-field class="text-percentage" [floatLabel]="'never'">
                            <input
                                type="number"
                                matInput
                                name="{{pass.value.key}}"
                                [formControlName]="pass.value.key"
                                (change)="textBoxChange(pass, $event)"
                                [readonly]="pass.index==4"
                            />
                        </mat-form-field>
                        <span class="error-message" *ngIf="form.get(pass.value.key).hasError('required') || form.get(pass.value.key).hasError('lessThanZero')">
                            Pass percentage must not be empty</span
                        >
                        <span class="error-message" *ngIf="form.get(pass.value.key).hasError('max') || form.get(pass.value.key).hasError('min')"
                            >Pass percentage must be 100</span
                        >
                        <span class="error-message" *ngIf=" form.get(pass.value.key).hasError('notMatch')"
                            >Pass percentage must be less than pass {{pass.index+1}}.</span
                        >
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
<div class="modal-footer">
    <!-- [disabled]="saveDisabled()" -->
    <button type="button" class="btn primary-ebtn" (click)="Save()" >Save & Recalculate</button>
    <button type="button" class="btn secondary-ebtn" (click)="closeModal()">Cancel</button>
</div>
